export const environment = {
  production: true,
  backendBaseUrl: "/api",
  entraClientId: "3c99838b-2d33-41e6-a93c-485ff3c0ac61",
  entraAuthority: "https://sendoauth.ciamlogin.com/0ca510b3-1b38-4047-a5f8-758437bb751c",
  entraKnownAuthorities: ["sendoauth.ciamlogin.com"],
  backendScope: "api://13db009f-3d07-43c9-88af-4708307b0d71/access_as_user",
  redirectUri: "https://sendo-dev.rksoftcol.com/",
  postLogoutRedirectUri: "https://sendo-dev.rksoftcol.com/",
  metaAppId: "3120187264854705",
  metaEmbeddedSignupConfigId: "2544460149325712",
  metaGraphVersion: "v25.0",
  metaBusinessUrl: "https://business.facebook.com/latest/whatsapp_manager/",
};